import { Fragment, useEffect, useState } from "react";
import { ReactLenis } from "lenis/react";
import "./index.css";

type GithubMember = {
  id: number;
  login: string;
  avatar_url: string;
  html_url: string;
};
const ORG_NAME = "jiji-fyi";
const MEMBERS_PER_PAGE = 50;

async function fetchOrganizationMembers(): Promise<GithubMember[]> {
  const members: GithubMember[] = [];
  let page = 1;

  while (true) {
    const response = await fetch(
      `https://api.github.com/orgs/${ORG_NAME}/members?per_page=${MEMBERS_PER_PAGE}&page=${page}`,
      {
        headers: {
          Accept: "application/vnd.github+json",
          "X-GitHub-Api-Version": "2022-11-28",
        },
      },
    );

    if (!response.ok) {
      throw new Error(`GitHub API request failed with ${response.status}`);
    }

    const pageMembers = (await response.json()) as GithubMember[];
    members.push(...pageMembers);

    if (pageMembers.length < MEMBERS_PER_PAGE) {
      break;
    }

    page += 1;
  }

  return members;
}

export function App() {
  const [members, setMembers] = useState<GithubMember[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrganizationMembers().then((loadedMembers) => {
      setMembers(loadedMembers);
      setLoading(false);
    });
  }, []);

  function memberNames() {
    return members.map((member: GithubMember, index: number) => (
      <Fragment key={member.id}>
        {index == members.length - 1 && index > 0 ? "and " : ""}
        <a
          key={member.id}
          href={member.html_url}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
        >
          {member.login}
        </a>
        {members.length > 2 && index != members.length - 1 ? "," : ""}
        {index != members.length - 1 ? " " : ""}
      </Fragment>
    ));
  }

  return (
    <>
      <ReactLenis root />
      <div className="max-w-7xl mx-auto text-center relative z-10">
        <div className="flex items-center justify-center gap-4">
          {loading
            ? null
            : members
                .slice(0, 2)
                .map((member) => (
                  <img
                    key={member.id}
                    src={member.avatar_url}
                    alt={`${member.login}'s GitHub profile picture`}
                    className="h-12 w-12 rounded-full object-cover"
                  />
                ))}
        </div>
        <h1 className="text-lg">check back soon for the future of jiji.fyi</h1>
        {!loading && <h2>under construction by {memberNames()}.</h2>}
      </div>
    </>
  );
}

export default App;
